import React, { useState, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import classNames from 'classnames'
import { Container } from 'react-bootstrap'
import {
  SubscriptionTable,
  PaymentHistoryTable,
  useUserService,
} from '@abroad/components'
import API from '../utils/API'
import { PageHeader } from '../components/common'

const UserPlansAndPayments = () => {
  const [showHighlightedPart, setShowHighlightedPart] = useState(false)
  const { user } = useUserService()
  const location = useLocation()
  const history = useHistory()
  const query = new URLSearchParams(location.search)
  const hashValue = location.hash.substring(1)
  const isPaymentIdHash = hashValue.startsWith('paymentId=')
  const sowId =
    localStorage.getItem('sowId') ||
    query.get('sowId') ||
    (!isPaymentIdHash && hashValue ? hashValue : null)
  const isRetryingPayment =
    localStorage.getItem('isRetryingPayment') || query.get('isRetryingPayment')

  const clientFname =
    user?.fname && String(user.fname).trim()
      ? String(user.fname).trim()
      : undefined

  useEffect(() => {
    if (sowId) {
      const newUrl = query.get('sowId')
        ? isRetryingPayment
          ? `${window.location.pathname}/coaching-plan/${sowId}?isRetryingPayment=${isRetryingPayment}`
          : `${window.location.pathname}/coaching-plan/${sowId}`
        : `${window.location.pathname}#${sowId}`
      history.replace(newUrl)
      setShowHighlightedPart(true)
      const timeInterval = setInterval(() => {
        setShowHighlightedPart(false)
        localStorage.removeItem('sowId')
        localStorage.removeItem('isRetryingPayment')
        clearInterval(timeInterval)
      }, 3000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sowId, history])

  const renderPageHelmet = () => {
    return (
      <Helmet>
        <title>{'Plans And Payment | Abroad'}</title>
        <meta name='title' content={'Plans And Payment | Abroad'}></meta>
        <meta property='og:title' content={'Plans And Payment | Abroad'}></meta>
        <meta
          property='twitter:title'
          content={'Plans And Payment | Abroad'}></meta>
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/plans-payments`}></link>
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/plans-payments`}></meta>
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/plans-payments`}></meta>
      </Helmet>
    )
  }

  return (
    <>
      <main>
        {renderPageHelmet()}
        <section className='custom-col-lg-8 custom-col-10 custom-offset-lg-1'>
          <PageHeader
            title='Plans and Payments'
            showBackArrow={true}
            backArrowAction={() => {
              if (history.length > 1) {
                history.goBack()
              } else {
                history.push('/home')
              }
            }}
          />
        </section>
        <section className='container-fluid abroad-fs-exclude px-0 overflow-hidden'>
          <div className='py-4 bg-gray-100 row mt-32px'>
            <Container fluid className='custom-col-lg-8 custom-col-10 px-4'>
              <h2 className='font-montserrat font-semibold mb-0'>
                {user?.firstName}&nbsp;{user?.lastName}
              </h2>
              <p className={classNames('font-montserrat font-medium')}>
                {user?.email}
              </p>
            </Container>
          </div>
        </section>
        <section className='plan-payment pt-3 custom-col-lg-8 custom-col-10 custom-offset-lg-1'>
          <SubscriptionTable
            isTogglePayment={true}
            showHighlightedPart={showHighlightedPart}
            API={API}
            userId={user?._id}
            clientName={clientFname}
          />
          <PaymentHistoryTable
            setShowHighlightedPart={setShowHighlightedPart}
            API={API}
            userId={user?._id}
            clientName={clientFname}
            isTogglePayment={true}
            isDiscardInfoIcon={false}
          />
        </section>
      </main>
    </>
  )
}

export default UserPlansAndPayments
